import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Contractors Insurance' },
	{
		name: 'description',
		content: 'We offer insurance for contractors.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Contractor's Insurance</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				We have products to cater to the needs of many different types of
				contractors.
			</p>
			<ul>
				<li>
					<Link
						to="/products-and-programs/arborists"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Arborists - Tree Trimming or Removal
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/carpenters"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Carpenters
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/drywallers"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Drywall Contractors
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/electricians"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Electricians
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/excavators"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Excavators
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/flooring"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Flooring Installers
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/general-contractors"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						General Contractors
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/heating-and-cooling-hvac"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						HVAC Technicians
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/landscapers"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Landscapers
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/masons"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Masons
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/painters"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Painters
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/plumbers"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Plumbers
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/roofing-insurance"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Roofers
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/tile-stone-and-marble"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Tilers
					</Link>
				</li>
				<li>
					<Link
						to="/products-and-programs/window-installation"
						prefetch="intent"
						className="text-blue-600 underline"
					>
						Window Installation
					</Link>
				</li>
			</ul>
		</main>
	)
}
